import { useCallback } from 'react';
import { Prompt } from '../models/PromptTypes';
import { usePrompt } from '../contexts/PromptContext';
import { ChatMessageStreamingResponse } from '../../../elements/chat-window/ChatWindow.types';

export function usePromptSaveAction(message: ChatMessageStreamingResponse, persona: string | undefined, setInitialPrompt: (p: Prompt) => void, setModalMode: (m: 'add' | 'edit' | 'copy') => void, setIsModalOpen: (v: boolean) => void) {
    const { getPrompt } = usePrompt();
    const { content, promptTemplateId, isPromptTemplateCreatedByMe } = message ?? {};

    const hasEditPermission = isPromptTemplateCreatedByMe;

    const edit = useCallback(async () => {
        if (!persona || !promptTemplateId) return console.warn('No persona or promptTemplateId provided for editing prompt', { persona, promptTemplateId });

        const existingPrompt = await getPrompt(persona, promptTemplateId);

        if (existingPrompt) {
            setInitialPrompt({ ...existingPrompt, content: content || '' });
            setModalMode('edit');
            setIsModalOpen(true);
            return;
        }
    }, [persona, promptTemplateId, getPrompt, setInitialPrompt, content, setModalMode, setIsModalOpen]);


    const add = useCallback(async () => {
        setInitialPrompt({
            key: '',
            title: '',
            description: '',
            content: content || '',
            assistant_key: persona || '',
            category: '',
            is_public: true,
            created_by: '',
            created_by_name: '',
            updated_by: '',
            tags: '',
            usage_count: 0,
            created: '',
            updated: '',
            last_used: '',
        });
        setModalMode('add');
        setIsModalOpen(true);
    }, [content, persona, setInitialPrompt, setIsModalOpen, setModalMode]);

    return hasEditPermission ? edit : add;
}
